import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import './RenderTextareaField.css';

const RenderTextareaField = (props) => {
  const {
    input,
    label,
    id,
    rows,
    cols,
    required,
    placeholder,
    maxChars,
    disabled,
    meta,
    className,
    wrap,
    onKeyDown,
    autoFocus,
    readOnly,
    minChars,
  } = props;
  const touched = meta && meta.touched;
  const error = meta && meta.error;
  const hasError = touched && error;
  const inputLength = (input && input.value && input.value.length) || 0;

  const classes = cx('textarea-field', 'render-field', 'zola-ui', 'form-group', className, {
    'has-error': hasError,
  });

  const maxInvlaid = maxChars && inputLength > maxChars;
  const lengthInvalid = maxInvlaid; // we don't treat min as invalid as that is the default state

  return (
    <div className={classes}>
      {label && id && (
        <label htmlFor={id}>
          {label}
          {required && <span className="text-danger danger-asterisk">*</span>}
        </label>
      )}
      <textarea
        {...input}
        className="form-control"
        id={id}
        rows={rows}
        cols={cols}
        placeholder={placeholder}
        disabled={disabled}
        onKeyDown={onKeyDown}
        wrap={wrap}
        style={{ verticalAlign: 'top' }}
        autoFocus={autoFocus}
        readOnly={readOnly}
      />
      {(maxChars || minChars) && (
        // min only:
        //  - too short   : 14 (min 30)
        //  - okay : 784 (min 30)
        // max only:
        //  - too long     : 568/500
        //  - okay : 468/500
        // min+max:
        //  - too short:   14/500 (min 30)
        //  - too long:    568/500 (min 30)
        //  - okay:  310/500 (min 30)
        <span className={`pull-right char-count text-${lengthInvalid ? 'danger' : 'muted'}`}>
          {inputLength}
          {maxChars && `/${maxChars}`}
          {minChars && minChars && ` (min ${minChars})`}
        </span>
      )}
      {touched && error && <span className="help-block text-danger">{error}</span>}
    </div>
  );
};

RenderTextareaField.propTypes = {
  input: PropTypes.shape({
    name: PropTypes.string.isRequired,
    value: PropTypes.string,
  }).isRequired,
  rows: PropTypes.number,
  cols: PropTypes.number,
  id: PropTypes.string,
  /** Required for accessibility with label */
  label: PropTypes.string,
  /** An id is also required for the label to appear. */
  required: PropTypes.bool,
  placeholder: PropTypes.string,

  /** Maximum number of characters.  Displayed as a character counter below.  Client is responsible for additional validation. */
  maxChars: PropTypes.number,

  /** Minimum number of characters.  Displayed as a character counter below.  Client is responsible for additional validation. */
  minChars: PropTypes.number,
  disabled: PropTypes.bool,
  meta: PropTypes.shape({
    touched: PropTypes.bool.isRequired,
    error: PropTypes.string,
  }),
  className: PropTypes.string,
  wrap: PropTypes.string,
  onKeyDown: PropTypes.func,
  autoFocus: PropTypes.bool,
  readOnly: PropTypes.bool,
};

export default RenderTextareaField;
